import { render, staticRenderFns } from "./red.vue?vue&type=template&id=0b621592&scoped=true&"
import script from "./red.vue?vue&type=script&lang=js&"
export * from "./red.vue?vue&type=script&lang=js&"
import style0 from "./red.vue?vue&type=style&index=0&id=0b621592&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b621592",
  null
  
)

export default component.exports